<div [ngClass]="theme.getThemeClass()" class="divShadowFeed">
  @if (loadingThings) {
    <div class="table-loading-placeholder">
      <div class="loader"></div>
    </div>
  } @else {
  <nav class="shadow-feed-header-nav">
    <!-- Row 1: Dates -->
    <div class="grid-container">
    
       <!-- Row 3: Client and Group selectors -->
    @if (!allThingsShadowFeed) {
      <div class="sort-by-group"> 
        <label class="sort-by-group-label" for="deviceClient">{{
          "devicecreateLabelClient" | translate
        }}</label>
        <select
          class="form-control"
          id="deviceClient"
          name="deviceClient"
          [(ngModel)]="selectedClient"
          (change)="onClientChange()"
        >
          <option [ngValue]="''" selected>
            {{ "devicecreateSelectClient" | translate }}
          </option>
          @for (client of thingClient; track client.client_id) {
            <option [ngValue]="client.client_id">
              {{ client.legal_name }}
            </option>
          }
        </select>
      </div>

      <div class="sort-by-group">
        <label class="sort-by-group-label">{{
          "deviceGroup" | translate
        }}</label>
        <select
          [(ngModel)]="filterThingGroup"
          class="form-control sort-by-group-select"
          name="thingGroup"
          (change)="onGroupChange()"
        >
          @for (option of thingGroupOptions; track option.value) {
            <option [ngValue]="option.value">
              {{ option.label | translate }}
            </option>
          }
        </select>
      </div>

      <div class="sort-by-group">
        <label class="sort-by-group-label">{{
          "deviceSubGroup" | translate
        }}</label>
        <select
          [(ngModel)]="filterThingSubGroup"
          class="form-control sort-by-group-select"
          name="thingSubGroup"
          (change)="onSubGroupChange()"
        >
          @for (subGroup of clientSubGroups || []; track subGroup.sub_groupID) {
            <option [ngValue]="subGroup.sub_groupID">
              {{ subGroup.sub_group_name }}
            </option>
          }
        </select>
      </div>
      
    }

    
      <div class="form-group">
        <div class="force-column">
          <label class="form-label">{{ "startingDate" | translate }}</label>
          <input
          [(ngModel)]="startDateShadowFeed"
          class="form-control"
          type="date"
          />
        </div>
      </div>
      <div class="form-group">
        <div class="force-column">
          <label class="form-label">{{ "endDate" | translate }}</label>
          <input
          [(ngModel)]="endDateShadowFeed"
          class="form-control"
          type="date"
          />
        </div>
      </div>
      <div class="shadow-feed-actions">
          <button class="btn btn-search-shadow-feed" (click)="getShadowFeed()">
            {{ "search" | translate }}
          </button>
          <button
            class="btn btn-reset-shadow-feed"
            (click)="resetDeviceFilters()"
          >
            {{ "clear" | translate }}
          </button>
        </div>
    </div>


    <!-- Row 2: Devices multiselect + actions -->
    
    <div class="shadow-feed-row">
      <div class="force-column flex-grow">
        <div class="label-search-box-shadow-feed">
          <label class="form-label">
            {{ "devices" | translate }} ({{ things.length }})
          </label>
          <div class="search-box-shadow-feed">
            <div class="toggle-filter-box">
              <div class="toggle-stack-shadow-feed">
                <div class="filter-toggle">
                  <label class="switch">
                    <input
                    type="checkbox"
                    [ngModel]="allThingsShadowFeed"
                    name="devices"
                    (change)="onChangeAllThingsShadowFeed($event)"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="toggle-box-shadow-feed">
                  <label class="devices-toggle">{{ "allDevices" | translate }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative">
          <app-custom-multi-select
            [(ngModel)]="selectedThingsShadowFeed"
            class="form-control ng-select device-multiselect-shadow-feed"
            [multiple]="true"
            #thingsShadowFeed
            [options]="things"
            bindLabel="id"
            bindValue="id"
          ></app-custom-multi-select>
        </div>
      </div>
      
    </div>
    



  </nav>

  <section class="shadow-feed-table-section-desktop">
    <div class="horizontal-scroll-container">
      @if (loading) {
        <div class="table-loading-overlay">
          <div class="loader"></div>
        </div>
      }
      <table class="table table-hover table-shadow-feed">
        <thead>
          <tr>
            <th
              [ngClass]="theme.getThemeClass()"
              class="hide-small-screen table-header-last-activity"
              scope="col"
            >
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('date')"
                href="javascript:void(0)"
              >
                {{ "activity" | translate }}
              </a>
            </th>
            <th
              [ngClass]="theme.getThemeClass()"
              scope="col"
              class="table-header-device"
            >
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                {{ "iotTabHeaderDevice" | translate }}
              </a>
              @if(sortDirection === 'asc' && sortBy === 'thingName'){
              <img src="./assets/arrow-up.png" width="10px" height="10px" />
              }

              @if (sortDirection === 'desc' && sortBy === 'thingName') {
                <img src="./assets/arrow-down.png" width="10px" height="10px" />
              }
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                {{ "temperature" | translate }}
              </a>
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                {{ "iotModalHeaderBattery" | translate }}
              </a>
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                {{ "VCC" | translate }}
              </a>
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                {{ "version" | translate }}
              </a>
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                {{ "signal" | translate }}
              </a>
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                NCT
              </a>
            </th>
            <th [ngClass]="theme.getThemeClass()" scope="col">
              <a
                [ngClass]="theme.getThemeClass()"
                (click)="sortItemLog('thing_name')"
                href="javascript:void(0)"
              >
                {{ "deviceConfigModalDistance" | translate }}
              </a>
            </th>
          </tr>
        </thead>

        <tbody>
          @for(deviceRow of thingsShadowLog.slice(0, loadedItemsShadowFeed +
          itemsPerPageShadowFeed);let i = $index; track deviceRow) {
          <tr #minhadiv class="rowTableData">
            <td class="hide-small-screen" [ngClass]="theme.getThemeClass()">
              {{ deviceRow.timestamp }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.thing_name }}
            </td>
            <td [ngClass]="theme.getThemeClass()">{{ deviceRow.tm2 }}°C</td>
            <td [ngClass]="theme.getThemeClass()">{{ deviceRow.bat }}V</td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.vcc }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.fdv }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.sig }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.nct }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.dst }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </section>
  @if (showScrollTop) {
    <button
      class="shadow-feed-scroll-top"
      type="button"
      (click)="scrollToTop()"
      [attr.aria-label]="'scrollToTop' | translate"
      title="{{ 'scrollToTop' | translate }}"
    >
      ↑
    </button>
  }
  }
</div>
